'use client';

import type { ComponentProps, MouseEvent as ReactMouseEvent } from 'react';

import type { RoundTable } from '@/types';

import { Card } from '../Card/Card';

import { PlayCircleFilled } from './PlayCircleFilled';

import styles from './Roundtable.module.scss';

type Props = ComponentProps<typeof Card> & {
    video: RoundTable['video'];
};

export function RoundtableCard({ video, ...restProps }: Props) {
    function handleOpenVideoModal(event: ReactMouseEvent<HTMLAnchorElement, MouseEvent>) {
        // Ignore when event comes from a 'Read more" link.
        // `stopPropagation` was not used inside of Card component
        // in order to preserve it being a server component.
        const shouldIgnore = (event.target as any)?.tagName === 'A';
        const shouldOpenNewTab = Boolean(event.metaKey || event.ctrlKey);

        if (shouldIgnore || shouldOpenNewTab) {
            return;
        }

        event.preventDefault();
        window.location.hash = `video-${video.videoId}-${video.type}`;
    }

    return (
        <Card
            {...restProps}
            className={styles.card}
            imageAddon={<PlayCircleFilled className={styles.playIcon} />}
            onClick={handleOpenVideoModal}
        />
    );
}
